import VcomProvider from '~/zf/frontend/VcomProvider';
export default VcomProvider;
